import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Popover } from 'react-bootstrap';
import { ApiScreeningHitClearanceState } from '../../../api/models';
import FormattedDateTime from '../../../common/datetime/FormattedDateTime';
import './ClearanceDetails.css';
import RmsPopover from '../../../common/popover/RmsPopover';

interface Props {
  clearance: ApiScreeningHitClearanceState;
}

const ClearanceDetails = ({ clearance }: Props) => {
  const clearanceDetailsPopover = () => (
    <Popover id='person-details-popover'>
      <Popover.Header as='h3'>{clearance.reason}</Popover.Header>
      <Popover.Body>
        <div className='clearance-details-popover-content'>
          <hr />
          <Row>
            <Col md={3}>
              <h5>Details</h5>
            </Col>
            <Col md={9}>
              <span className='small'>{clearance.details}</span>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col md={3}>
              <h5>Rule</h5>
            </Col>
            <Col md={9}>
              <pre>{clearance.content}</pre>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col md={3}>
              <h5>Activated</h5>
            </Col>
            <Col md={9}>
              <FormattedDateTime date={clearance.activatedAt} showTime />
            </Col>
          </Row>
          <hr />
          {clearance.deactivatedAt && (
            <Row>
              <Col md={3}>
                <h5>Deactivated</h5>
              </Col>
              <Col md={9}>
                <FormattedDateTime date={clearance.deactivatedAt} showTime />
              </Col>
            </Row>
          )}
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <RmsPopover overlay={clearanceDetailsPopover()}>
      <span className='hover-link'>{clearance.details}</span>
    </RmsPopover>
  );
};

export default ClearanceDetails;
